module.exports = __webpack_public_path__ + "9bd0c5ab7e4d3856337fb1df67437d98.png";